export default __webpack_public_path__ + "static/media/deal.fe17fe0a.jpg";